import { AppComponent } from './app/app.component';
import { WebcamModule } from 'ngx-webcam';
import { ServiceWorkerModule } from '@angular/service-worker';
import { PlatformModule } from '@angular/cdk/platform';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { LOCALE_ID, isDevMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { routes } from './app/app-routing';
import {
    InMemoryScrollingFeature,
    InMemoryScrollingOptions,
    provideRouter,
    withInMemoryScrolling
} from "@angular/router";

// Locale
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
registerLocaleData(localeIt);
// Amplify
import { Amplify } from 'aws-amplify';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import awsConfig from './aws-config';
Amplify.configure(awsConfig);
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-angular';
import {headersInterceptor} from "../../../packages/fe/core/headers-interceptor";
I18n.putVocabularies(translations);
I18n.setLanguage('en-US');
// PrimeNG
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
// import Aura from '@primeuix/themes';
import {ConfirmationService, MessageService} from "primeng/api";
import {MyPreset} from "./theme-preset";
// FontAwsome
import { faColumns, faWindowMaximize, faCog, faCheck } from '@fortawesome/free-solid-svg-icons';
import {FaIconLibrary} from "@fortawesome/angular-fontawesome";

// Router scrolling behaviour
const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};
const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(BrowserModule, PlatformModule,
          ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }), WebcamModule),
        { provide: LOCALE_ID, useValue: 'it-IT' },
        provideAnimations(),
        // provideHttpClient(withFetch(),withInterceptors([headersInterceptor])),
        provideHttpClient(withInterceptors([headersInterceptor])), // withFetch doesnt support progressReport
        provideRouter(routes, inMemoryScrollingFeature),
        provideAnimationsAsync(),
        providePrimeNG({
            ripple: true,
            theme: {
                preset: MyPreset,
                options: {
                    prefix: 'p',
                    darkModeSelector: '.dark-theme',
                    cssLayer: {
                        name: 'primeng',
                        order: 'tailwind, primeng'
                    }
                }
            }
        }),
        MessageService,
        ConfirmationService,
        {
            provide: 'IconLoader',
            useFactory: (library: FaIconLibrary) => {
                library.addIcons(faColumns, faWindowMaximize, faCog, faCheck);
            },
            deps: [FaIconLibrary],
            multi: true
        }
    ]
})
  .catch(err => console.error(err));
